export default "__VITE_ASSET__DRX_qRuz__"